import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiUrls } from "./ApiUrls";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FileResponseModel } from "../model/FileResponseModel";
import { Page } from "../model/Page";

import { BoardResponse } from "../model/BoardResponse";
import { ApplicantListModel } from "./ApplicantListModel";
import { AuditTrailModel } from "../model/AuditTrailModel";
import { AppointmentCountModel } from "../model/AppointmentCountModel";
import { Observable } from "rxjs";
// import { ForwardedHistoryModel } from "../model/ForwardedHistory";
import { NewAppointmentCountModel } from "../model/NewAppointmentCountModel";
//import { ForwardedHistoryModel } from "../model/ForwardedHistory";

@Injectable({
  providedIn: "root",
})
export class ApplicantStatusService {
  
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) {}
  // getApplicantList(
  //   // lotteryEventId: string,
  //   statusId: string,
  //   page: number,
  //   size: number,
  //   filterText?: string
  // ) {
  //   let reqParams =
  //     `?page=${page}&size=${size}` +
  //     (filterText ? `&filterText=${filterText}` : "");
  //   return this.httpClient.get<Page<ApplicantListModel>>(
  //     ApiUrls.getApplicantList
  //       .replace(`{statusId}`, statusId) + reqParams
  //   );
  // }

  getApplicantList(
    statusId: string,
    page: number,
    size: number,
    fromDate?: string,
    toDate?: string,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "") +
      (fromDate ? `&fromDate=${fromDate}` : "") +
      (toDate ? `&toDate=${toDate}` : "");
  
    return this.httpClient.get<Page<ApplicantListModel>>(
      ApiUrls.getApplicantList.replace(`{statusId}`, statusId) + reqParams
    );
  }
  getApplicantLists(
    statusId: string,
    page: number,
    size: number,
    fromDate?: string,
    toDate?: string,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "") +
      (fromDate ? `&fromDate=${fromDate}` : "") +
      (toDate ? `&toDate=${toDate}` : "");
  
    return this.httpClient.get<Page<ApplicantListModel>>(
      ApiUrls.getApplicantLists.replace(`{statusId}`, statusId) + reqParams
    );
  }

  getApplicantListAll(
    // lotteryEventId: string,
    statusId: string,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}&pagination="Y"` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<ApplicantListModel>>(
      ApiUrls.getApplicantList
        .replace(`{statusId}`, statusId) + reqParams
    );
  }

  fetchAppointmentDetail(appointmentId: number) {
    return this.httpClient.get<ApplicantListModel>(
      ApiUrls.fetchAppointmentDetail
      .replace("{appointmentId}", `${appointmentId}`)
    );
  }
  
  fetchOtherPersonList(appointmentId: number) {
    return this.httpClient.get<ApplicantListModel>(
      ApiUrls.fetchOtherPersonList
      .replace("{appointmentId}", `${appointmentId}`)
    );
  }


  fetchAppointDocFiles(appointmentId: number) {
    return this.httpClient.get<ApplicantListModel[]>(
      ApiUrls.fetchAppointmentDocFiles 
        .replace("{appointmentId}", `${appointmentId}`)
    );
  }

  rejectedAppointment(
    appointmentIds: string,
    remark: string,
    status: any
  ) {
   

    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${
        ApiUrls.saveRejectAppointment

        .replace("{appointmentId}", appointmentIds)
          .replace("{remark}", remark) 
      }`,
      null
    );
  }


  approveAppointment(
    appointmentIds: string,
    authorityAddress: string
  ) {
    return this.httpClient.post<{ authorityAddress: string; errorMessage: string }>(
      `${ApiUrls.saveApproveAppointment
        .replace("{appointmentId}", appointmentIds)
        .replace("{authorityAdress}", authorityAddress)
      }`,
      null
    );
  }
  
  
  forwardAppointment(
    appointmentIds: string,
    selectedOfficerKey:any,
    selectedSlotKey:any,
    remark: string,

  ) {
    console.log("HIii i am in Forward"); 

    return this.httpClient.post<{ remark: string; errorMessage: string }>(
      `${
        ApiUrls.saveForwardAppointment

        .replace("{appointmentId}", `${appointmentIds}`)
        .replace("{selectedOfficerKey}", `${selectedOfficerKey}`)
        .replace("{selectedSlotKey}", `${selectedSlotKey}`)
        .replace("{remark}", `${remark}`)

      }`,
      null
    );
  }

  RescheduleAppointment(
    appointmentIds: string,
    selectedSlotKey:any,
    remark: string,

  ) {
    console.log("HIii i am in RescheduleAppointment"); 

    return this.httpClient.post<{ remark: string; errorMessage: string }>(
      `${
        ApiUrls.RescheduleAppointment

        .replace("{appointmentId}", `${appointmentIds}`)
        .replace("{selectedSlotKey}", `${selectedSlotKey}`)
        .replace("{remark}", `${remark}`)

      }`,
      null
    );
  }
  // findAddress(
  //   appointmentId: any,
  // ) {
  //   console.log(appointmentId); 
  //   console.log("Hii I am here"); 

  //   return this.httpClient.get(
  //     `${
  //       ApiUrls.fetchAddress
  //         .replace("{appointmentId}", appointmentId)
  //     }`,
  //     null
  //   );
  // }

  findAddress() {
    console.log("Hii I am here");
    return this.httpClient.get<ApplicantListModel>(
      ApiUrls.fetchAddress
     
    );
  }

  fetchAuthorityListInit() {
    console.log("Hii I am here for Authoritylist");
    return this.httpClient.get<ApplicantListModel>(
      ApiUrls.fetchAuthorityList
    );  
  }

  

  fetchBoardList() {
    console.log("Hii I am Board");
    return this.httpClient.get<ApplicantListModel>(
      ApiUrls.fetchBoardList
    );  
  }
  findOpenSlotsRescheduled() {
    console.log("Hii I am here");
    return this.httpClient.get<ApplicantListModel>(
      ApiUrls.findOpenSlotsRescheduled
    );
  }
  
  
  findOpenSlots(selectedOfficerKey: any) {
    console.log(selectedOfficerKey); 
    console.log("Hii I am here");
    return this.httpClient.get<ApplicantListModel>(
      ApiUrls.findOpenSlots
      .replace("{selectedOfficerKey}", selectedOfficerKey)       
    );
  }

  fetchAuditTrail(
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<AuditTrailModel>>(
      ApiUrls.getAuditTrail + reqParams
        
    );
  }

  
  getEventList() {
    return this.httpClient.get<{status : string,errorMessage : string, event : string}>(
      ApiUrls.eventList
    );
  }

  fetchappointmentPendingCount() {
    return this.httpClient.get<AppointmentCountModel>(ApiUrls.fetchappointmentPendingCount);

  }

  fetchappointmentPendingCountToaday() {
    return this.httpClient.get<AppointmentCountModel>(ApiUrls.fetchappointmentPendingCountToaday);

  }

  fetchMonthlyApprovedAppointments(): Observable<any> {
    console.log("fetchMonthlyApprovedAppointments called");
    return this.httpClient.get<any>(ApiUrls.fetchMonthlyApprovedAppointments);
  }

  // getForwardedHistory(appointmentId: string): Observable<ForwardedHistoryModel[]> {
  //   console.log(appointmentId);
  //   return this.httpClient.get<ForwardedHistoryModel[]>(
  //     ApiUrls.getForwardedHistory.replace("{appointmentId}", appointmentId)
  //   );
  // }
  
//  getForwardedHistory(appointmentId: string): Observable<ForwardedHistoryModel[]> {
//  console.log(appointmentId);
//  return this.httpClient.get<ForwardedHistoryModel[]>(
//    ApiUrls.getForwardedHistory.replace("{appointmentId}", appointmentId)
//   );
//  }
   newfetchappointmentPendingCount() {
    return this.httpClient.get<NewAppointmentCountModel>(ApiUrls.newfetchappointmentPendingCount);

  }

  newfetchMonthlyApprovedAppointments(): Observable<any> {
    console.log("newfetchMonthlyApprovedAppointments called");
    return this.httpClient.get<any>(ApiUrls.newfetchMonthlyApprovedAppointments);
  }

      newfetchappointmentPendingCountToaday() {
      return this.httpClient.get<NewAppointmentCountModel>(ApiUrls.newfetchappointmentPendingCountToaday);

    }

    getBoards() {
    return this.httpClient.get<string[]>(ApiUrls.getBoards);
    }

    getDepartmentStats() {
    return this.httpClient.get<any[]>(ApiUrls.departmentStats);
   }

   getTodayPendingAppointments() {
    return this.httpClient.get<any[]>(ApiUrls.todayPendingAppointments);
   }

   getRecentActivities() {
  return this.httpClient.get<any[]>(ApiUrls.recentActivities);
  }

getBoardStats(boardName: string) {
  return this.httpClient.get<any>(
    `${ApiUrls.getBoardStats}?boardName=${boardName}`
  );
}

// getDepartmentsByBoard(boardName: string) {
//   return this.httpClient.get<any[]>(`${ApiUrls.boardDepartments}?boardName=${boardName}`);
// }

getDepartmentDetails(board: string, department: string) {
  return this.httpClient.get(
    `${ApiUrls.getdepartmentDetails}?boardName=${board}&departmentName=${department}`
  );
}
getBoardDepartments(boardName: string) {
  return this.httpClient.get<any[]>(
    `${ApiUrls.getBoardDepartments}?boardName=${boardName}`
  );
}

getDepartmentPerformance(boardName: string) {
  return this.httpClient.get<any[]>(
    `${ApiUrls.getDepartmentPerformance}?boardName=${boardName}`

  );
}
}
  
